import { EmptyResponse } from './for-api';
import { ApiGatewayRequestProcessingError } from '../errors';

export const fetchAndEnforceApiGatewayResponseData = async <T>(
  promiseFn: () => Promise<ApiGatewayResponse<T>>,
): Promise<T | undefined> => {
  const { data, status, message, errors } = await promiseFn();
  if (status !== 'Success') {
    throw new ApiGatewayRequestProcessingError(
      message,
      500,
      errors,
      errors.map(
        (error) => `${error.code}: ${error.message} (${error.description})`,
      ),
    );
  }
  return data;
};

interface ApiGatewayError {
  code?: string;
  message?: string;
  description?: string;
}

export class ApiGatewayResponse<TModel extends EmptyResponse> {
  constructor(
    public data?: TModel,
    public message: string = '',
    public errors: ApiGatewayError[] = [],
    public status: string = 'Failure',
  ) {}
}
